import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=7328c6bb&scoped=true"
import script from "./BrandList.vue?vue&type=script&lang=js"
export * from "./BrandList.vue?vue&type=script&lang=js"
import style0 from "./BrandList.vue?vue&type=style&index=0&id=7328c6bb&prod&lang=scss&scoped=true"
import style1 from "./BrandList.vue?vue&type=style&index=1&id=7328c6bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328c6bb",
  null
  
)

export default component.exports